import React from 'react'
import styled from '@emotion/styled'
import { measurements } from '@mobi/component-library/Foundations'
import { shouldApplySafeAreaBottomPadding } from '@core/Settings/cssConditions'
import { startListening } from '@core/Store/listenerMiddleware'
import {
  KAMBI_BETSLIP_DIV_CLASS,
  KAMBI_BETSLIP_WRAPPER_DIV_ID,
} from '@core/Areas/KambiClient/constants'
import { setKambiBetslipVisibility } from '@core/Areas/KambiClient/Store'

/** Renders Kambi bet slip - NOT within react-router routes */
export const KambiBetSlip: React.FC = React.memo(() => {
  const kambiBetSlipElRef = React.useRef<HTMLDivElement>(null)

  React.useEffect(() => {
    if (!kambiBetSlipElRef.current) return undefined
    const betSlipEl = kambiBetSlipElRef.current

    const dispose = startListening({
      actionCreator: setKambiBetslipVisibility,
      effect: action => (action.payload ? betSlipEl.removeAttribute('style') : undefined),
    })
    return () => dispose()
  }, [])

  return (
    <WrapperStyled>
      <div
        ref={kambiBetSlipElRef}
        id={KAMBI_BETSLIP_WRAPPER_DIV_ID}
        className={`${KAMBI_BETSLIP_DIV_CLASS} mobi__unset-globals`}
      />
    </WrapperStyled>
  )
})

KambiBetSlip.displayName = 'KambiBetSlip'

// ======
// Styles
// ======

const WrapperStyled = styled.div({
  '.mod-KambiBC-betslip': {
    maxHeight: `calc(100dvh - (${measurements.mobi.bottomTabsHeight} + var(--safe-area-inset-bottom, 0px))) !important`,
  },

  ...(shouldApplySafeAreaBottomPadding
    ? {
        '.mod-KambiBC-betslip, .mod-KambiBC-betslip__outer-wrapper-mask': {
          transform: `translateY(calc(calc(${measurements.mobi.bottomTabsHeight} + var(--safe-area-inset-bottom, 0px)) * -1))`,
        },

        '.mod-KambiBC-betslip-container--pinned .mod-KambiBC-betslip, .mod-KambiBC-betslip-container--pinned .mod-KambiBC-betslip__outer-wrapper-mask':
          {
            transform: 'unset',
          },
      }
    : {}),
})
